import { AnsweringClient } from "../clients/answeringClient";

export interface GenericAnonControllerDelegate {
  inviteSuccess(genericAnonToken: string): void;
  inviteFailed(): void;
  setRedirectingText(value: string | null): void;
}

export class GenericAnonController {
  constructor(private delegate: GenericAnonControllerDelegate, private client = new AnsweringClient()) {}

  public async registerInvite(token: string) {
    this.delegate.setRedirectingText("Atualizando dados...");

    try {
      const result = await this.client.generateAnonToken(token);
      const { anonToken } = result.data;
      if (Math.trunc(result.status / 100) !== 2) return this.delegate.inviteFailed();
      this.delegate.inviteSuccess(anonToken);
    } catch (error) {
      this.delegate.inviteFailed();
    }
  }
}
